/* Module of functions for interacting with the ALEX Monitor service
 * All functions return promises that resolve to JSON objects.
 */

import {ScanningErrors} from 'services/errorCodes';

let ALEXMonitor_ENDPOINT = "http://localhost:4651"

function returnNull(err){
  console.error(err);
  return null;
}

export function ALEXMonitor_Status(){
    return fetch(ALEXMonitor_ENDPOINT, {cache: "no-store"})
           .then(response => response.json())
           .catch(returnNull);
}

/*
{
    "SmartLabDeviceName": "SmartLab 1",
    "SmartLabClientVersion": "1.0.0.0",
    "SmartLabServiceVersion": "2.10.0.6",
    "SmartLabFirmwareVersion": "0.31126",
    "SmartLabAvailableFirmwareVersion": "1.5",
    "TestConnectVersion": null,
    "ALEXProMonitoServiceVersion": "1.0.0.0"
}
*/